import React, { Component } from 'react';
import { Card, CardColumns, Badge, Button, Form, InputGroup, FormText, FormControl, Table } from 'react-bootstrap';
import apiFetch from "../utils/apiFetch";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPause, faPlay, faTrashAlt, faPen, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'

class MyAlbum extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            photos: null,
            sortBy: "1",
            stats: null
        }

    }

    componentDidMount() {
        this.loadMyAlbum()
    }

    loadMyAlbum = () => {
        apiFetch('albums.my', {

        }).then((result) => {
            console.log(result);
            if (!result.success) {
                //this.setState({need_login: true});
                //window.location.replace("/auth");
                /*if (result.error)
                    alert(result.error);*/

            } else {
                console.log('photos loaded')
                this.setState({photos: result.items, stats: result.stats})
                this.sortByLikesDesc()
            }
        })
    }

    sortByLikesDesc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.likes < b.likes) {
                return 1;
            }
            if (a.likes > b.likes) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    sortByLikesAsc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.likes > b.likes) {
                return 1;
            }
            if (a.likes < b.likes) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    sortByDislikesDesc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.dislikes < b.dislikes) {
                return 1;
            }
            if (a.dislikes > b.dislikes) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    sortByDislikesAsc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.dislikes > b.dislikes) {
                return 1;
            }
            if (a.dislikes < b.dislikes) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    sortByDateDesc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.date < b.date) {
                return 1;
            }
            if (a.date > b.date) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    sortByDateAsc = () => {
        if (!this.state.photos)
            return;

        const tmp = this.state.photos.sort(function (a, b) {
            if (a.date > b.date) {
                return 1;
            }
            if (a.date < b.date) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        this.setState({photos: tmp});
    }

    onChangeSortSelect = (e) => {
        this.setState({sortBy: event.target.value});
        switch (event.target.value) {
            case "1":
                this.sortByLikesDesc();
                break;
            case "2":
                this.sortByLikesAsc();
                break;
            case "3":
                this.sortByDislikesDesc();
                break;
            case "4":
                this.sortByDislikesAsc();
                break;
            case "5":
                this.sortByDateDesc();
                break;
            case "6":
                this.sortByDateAsc();
                break;
        }
    }

    updateAlbum = () => {
        apiFetch('albums.updatemy', {

        }).then((result) => {
            this.loadMyAlbum()
        })
    }

    render() {
        return (
            <React.Fragment>
                <h2>Информация о моём альбоме</h2>
                <hr/>
                <Form.Group>
                    <span>Для получения актуальных данных после удаления или добавления фотографий нажмите на кнопку Обновить.</span><br/>
                    <Button variant="primary" onClick={this.updateAlbum}>Обновить</Button>
                </Form.Group>
                <hr/>
                <Form.Group>
                    <Form.Label>Сортировать</Form.Label>
                    <Form.Control as="select" onChange={this.onChangeSortSelect} value={this.state.sortBy}>
                        <option value={1}>По лайкам (по убыванию)</option>
                        <option value={2}>По лайкам (по возрастанию)</option>
                        <option value={3}>По дизлайкам (по убыванию)</option>
                        <option value={4}>По дизлайкам (по возрастанию)</option>
                        <option value={5}>По дате (сначала новые)</option>
                        <option value={6}>По дате (сначала старые)</option>
                    </Form.Control>
                </Form.Group>
                {this.state.photos &&
                    <div>
                        <span>Всего фотографий в альбоме: <b>{this.state.photos.length}</b></span><br/>
                    </div>
                }
                <div className="row justify-content-center row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
                {this.state.photos && this.state.photos.map((photo) =>
                    <div className="col mt-4">
                        <Card key={photo.id}>
                            <a target="_blank" href={photo.link}><Card.Img style={{height: 140}} variant="top" src={photo.photo_url}/></a>
                            <Card.Body>
                                <Card.Text style={{textAlign: "center"}}>
                                    <Badge style={{fontSize: "1em"}} variant="success"><FontAwesomeIcon icon={faThumbsUp}/> {photo.likes}</Badge>
                                    <Badge style={{fontSize: "1em"}} variant="danger"><FontAwesomeIcon icon={faThumbsDown}/> {photo.dislikes}</Badge>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                )}
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(MyAlbum);



// WEBPACK FOOTER //
// ./src/components/MyAlbum.js